import React, { PropTypes } from 'react'
import Panel from 'react-bootstrap/lib/Panel'

const PanelHeader = ({ children, header }) => (
  <Panel header={header}>
    {children}
  </Panel>
)

PanelHeader.propTypes = {
  children: PropTypes.node,
  header: PropTypes.node,
}

export default PanelHeader



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/panel-header.js